<template>
  <div class="new-buyer-bank-container p-3" :class="{ 'add-form': openForm }">
    <!-- buyer bank form -->
    <buyer-bank-form
      v-if="openForm"
      new-bank
      @close="closeBankForm"
      @save-data="saveBankData"
      :loading="loading"
    />

    <!-- Actions -->
    <div v-else class="d-flex justify-content-between align-items-center">
      <p class="label drip-body m-0">{{ $t('coverLetter.addBuyerLabel') }}</p>
      <b-button
        @click="openBankForm"
        variant="primary"
        class="primary-outlined d-flex"
      >
        {{ $t('coverLetter.add') }}
        <b-icon-plus class="color-wealthy-green-500" />
      </b-button>
    </div>
  </div>
</template>

<script>
import buyersService from '@/services/buyers'
import BuyerBankForm from '@/components/invoices/Add/Forms/funding/BuyerBankForm'

export default {
  props: {
    buyer: {
      type: Object,
      required: false,
      default: () => ({})
    }
  },
  data() {
    return {
      openForm: false,
      loading: false
    }
  },
  components: {
    BuyerBankForm
  },
  methods: {
    openBankForm() {
      this.openForm = true
    },
    closeBankForm() {
      this.openForm = false
    },
    async saveBankData(formFields) {
      this.loading = true
      try {
        await buyersService.addBuyerBank(this.buyer.id, {
          vars: {
            cover_letter_instruction: {
              buyer_bank_name: formFields.bankName,
              buyer_bank_address: formFields.bankAddress,
              swift_code: formFields.swift.toString().toUpperCase(),
              post_code: formFields.post,
              contact_name: formFields.contactName,
              contact_phone: formFields.contactNumber
            }
          }
        })
        this.$notify({
          title: this.$t('coverLetter.successMsg'),
          type: 'success'
        })
        this.loading = false
        this.closeBankForm()

        this.$emit('fetch-bank-list')
      } catch (e) {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';

.new-buyer-bank-container {
  background: $sky-blue-50;
  border: 1px solid $sky-blue-400;
  border-radius: 8px;
  padding: 16px;
  &.add-form {
    background: $white;
  }

  .label {
    color: $noble-blue-500;
  }

  .primary-outlined {
    border-color: transparent;
    background-color: transparent;
    color: $wealthy-green-500;
    font-size: 1.25rem;
    font-weight: 700;
    &:hover {
      background-color: $wealthy-green-50;
    }
    &:active {
      background-color: $wealthy-green-50;
      color: $wealthy-green-500;
    }
  }
}
</style>
